type TokenGetter = (forceRefresh?: boolean) => Promise<string | null>;

let _tokenGetter: TokenGetter | null = null;

export function setTokenProvider(fn: TokenGetter): void {
    _tokenGetter = fn;
}

export async function getAccessToken(forceRefresh?: boolean): Promise<string | null> {
    if (!_tokenGetter) return null;
    try {
        return await _tokenGetter(forceRefresh);
    } catch (err) {
        console.warn('Failed to acquire access token:', err);
        return null;
    }
}
